import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import ApiService from '../../services/ApiService'
import { DATA_ALREADY_EXIST, DATA_ON_PROCESS } from '../../utility/ResponseConstant'
import { showAlert } from '../../utility/SweetAlert'

const InteractorFundWithdrawFormAction = () => {
  const { t } = useTranslation()
  const { account } = useSelector((state) => state.account)

  const addWithdraw = useCallback(
    (payload = {}, loadingCallback = () => {}) => {
      const payloadRequest = {
        ...payload,
        account_uid: account.uid,
        created_by: account.full_name,
      }
      loadingCallback(true)
      ApiService.jsonRequest('/fund-withdraw/create', payloadRequest, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.fund_withdraw_is_processed`),
            timer: 5000,
          })
          window.location.reload()
        } else {
          if (response.messages === DATA_ALREADY_EXIST || response.messages === DATA_ON_PROCESS) {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 5000,
            })
          } else {
            showAlert({
              icon: 'error',
              message: t(`response_message.internal_server_error`),
              timer: 5000,
            })
          }
        }
      })
    },
    [account.full_name, account.uid, t],
  )

  return { addWithdraw }
}

export default InteractorFundWithdrawFormAction
